import styled from "@emotion/styled";
import {
  lightGreen,
  lightGreenTagTransparent,
  lightGrey2,
  lightGrey2Transp,
  red,
  redTagTransparent,
} from "@stepfinance/react";
import { Tag } from "antd";
import type { FC } from "react";

import { formatPercent } from "../../utils/utils";

interface PercentageTagProps {
  percent: number;
}
export const PercentageTag: FC<PercentageTagProps> = ({ percent }) => {
  const [tagBackground, tagTextColor, tagSign] = getTagColors(percent);
  return (
    <StyledTag color={tagBackground} textColor={tagTextColor}>
      {tagSign}
      {formatPercent(2).format(percent).replace("-", "")}
    </StyledTag>
  );
};

export const StyledTag = styled(({ textColor, ...props }) => <Tag {...props} />)<{ textColor: string }>`
  color: ${({ textColor }) => textColor};
  margin-right: 0;
  margin-left: 10px;
  height: 22px;
`;

type TagColorsSign = [tagBackground: string, tagTextColor: string, sign: "+" | "" | "-"];

const getTagColors = (value: number): TagColorsSign => {
  if (value < 0.0001 && value > -0.0001) {
    return [lightGrey2Transp, lightGrey2, ""];
  } else if (value > 0) {
    return [lightGreenTagTransparent, lightGreen, "+"];
  } else {
    return [redTagTransparent, red, "-"];
  }
};
